export const mapEntityEntriesToTableEntries = (entries) => {
  const headers = [];
  const rows = [];

  entries?.forEach((entry) => {
    headers.push({ name: entry.name, language: entry.language });
    entry.phrases?.forEach((word, index) => {
      if (rows[index]) {
        rows[index].push(word);
      } else {
        rows.push([word]);
      }
    });
  });

  return { headers, rows };
};

export const mapTableEntriesToEntityEntries = (headers, rows) => {
  const transposed = rows[0].map((_, colIndex) => rows.map((row) => row[colIndex]));
  const entries = headers.map((header, index) => ({ ...header, phrases: transposed[index] }));
  return entries;
};

export const downloadAsCSV = (headers, rows, title) => {
  // Step 1 Extract column names
  const headerRow = headers.map((header) => header.name).join(','); // Header row
  // Step 2: Convert rows into CSV format
  const csvRows = rows.map((row) => row.join(','));

  // Step 3: Combine headers and rows
  const csvContent = [headerRow, ...csvRows].join('\n');

  // Step 4: Create a Blob and download the file
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = title;
  document.body.appendChild(a);
  a.click();

  // Cleanup
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
